import { CommonModule } from "@angular/common";
import { Component, inject, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { resolveNotificationUrl } from "@models/enums/notification-event-type.enum";
import { Notification, NotificationFilter } from "@models/notification";
import { PaginatorModule, PaginatorState } from "primeng/paginator";
import { NotificationItemComponent } from "../../shared/components/notification-item/notification-item.component";
import { NotificationService } from "../../services/notification.service";
import { NotificationStore } from "../../services/notification.store";
import { AppLayoutComponent } from "../../../shared/components/app-layout/app-layout.component";
import { PageHeaderComponent } from "../../../shared/components/page-header/page-header.component";

const PER_PAGE = 20;

@Component({
  selector: "app-notifications-page",
  standalone: true,
  imports: [
    CommonModule,
    PaginatorModule,
    NotificationItemComponent,
    AppLayoutComponent,
    PageHeaderComponent,
  ],
  templateUrl: "./notifications-page.component.html",
  styleUrl: "./notifications-page.component.scss",
})
export class NotificationsPageComponent implements OnInit {
  private readonly notificationService = inject(NotificationService);
  private readonly router = inject(Router);
  protected readonly store = inject(NotificationStore);

  ngOnInit(): void {
    this.load(1);
  }

  setFilter(filter: NotificationFilter): void {
    if (this.store.filter() === filter) {
      return;
    }
    this.store.setFilter(filter);
    this.load(1);
  }

  onPageChange(event: PaginatorState): void {
    const page = (event.page ?? 0) + 1;
    this.load(page);
  }

  markAllRead(): void {
    if (this.store.unreadCount() === 0) {
      return;
    }
    this.notificationService.markAllRead().subscribe(() => {
      this.store.zeroUnread();
    });
  }

  handleRead(notification: Notification): void {
    this.store.markReadLocally(notification.id);
    this.notificationService.markRead(notification.id).subscribe();
  }

  handleOpenAction(notification: Notification): void {
    const url = resolveNotificationUrl(notification);
    if (url) {
      this.router.navigateByUrl(url);
    }
  }

  private load(page: number): void {
    this.store.setLoading(true);
    const unreadOnly = this.store.filter() === "unread";
    this.notificationService
      .list(page, PER_PAGE, unreadOnly)
      .subscribe((result) => this.store.setFromList(result));
  }
}
